import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const addRecordingToPlaylist = async ({
  playlistId,
  recordingId,
  orgId,
}: {
  playlistId: string;
  recordingId: string;
  orgId: string;
}): Promise<void> => {
  const response = await axiosClient.post(
    `/${orgId}/playlists/${playlistId}/recordings`,
    { recordingId },
  );
  return response.data;
};

function useAddRecordingToPlaylist(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { playlistId: string; recordingId: string; orgId: string }
  >,
) {
  return useMutation({
    mutationFn: addRecordingToPlaylist,
    ...mutationOptions,
  });
}

export { useAddRecordingToPlaylist };
